// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KHav","right":"styles_right__3ZhWp"};